<template>
  <div class="page-component-wrapper">
    <grid
      :config="gridConfig"
      @handleCustomButtonGrid="goToQuickRFQ"
    >
      <template  v-slot:column-control-left="{ row }">
        <li v-if="isAvailableAddRFQ">
          <el-button style="line-height: 1;" size="mini" @click="goToQuickRFQ({ row })" :disabled="row.statusID !== 1" :type="row.statusID === 6 ? 'danger' : 'primary'">
            {{L10n('quick-rfq')}}
          </el-button>
        </li>
        <li>
          <el-button style="line-height: 1;" size="mini" @click="copyStock({ row })" type="info" icon="el-icon-copy-document">
            {{L10n('copy-to-clipboard')}}
          </el-button>
        </li>
      </template>
    </grid>
    <stock-editor-wrapper
      editorId="stock-item"
      editorApi="Stocks/Get/"
      :isDisabledForm="isDisabledForm"
      :config="{ id: gridConfig.id }"
      :onQuickRFQ="goToQuickRFQ"
    />
  </div>
</template>

<script>
import gridConfig from './GridConfig.js'
import { ServiceStocks } from '@/services/Stocks'

export default {
  name: 'StocksParts',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'stock-editor-wrapper': () => import(/* webpackChunkName: 'Stock' */ './EditorWrapper')
  },
  computed: {
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    gridConfig () {
      const sourceConditions = [
        ...this.dataSourceCondition.records,
        {
          id: 'NULL',
          title: this.L10n('value-null')
        }
      ]
      return gridConfig({ sourceConditions })
    },
    isDisabledForm () {
      return !this.permission(this.$store.getters.get('permissions'), 'isAllowToEditStocks')
    },
    isAvailableAddRFQ () {
      return this.permission(this.$store.getters.get('permissions'), 'isAllowToEditRFQs')
    }
  },
  methods: {
    goToQuickRFQ ({ row }) {
      this.$router.push({
        name: 'RFQQuickRFQPartAvailable',
        query: {
          'quick-rfq-part': `edit[${row.partID}]`,
          'quick-rfq-part-stock-id': row.id
        }
      })
    },
    makeClipboardText ({ row }) {
      return ServiceStocks.makeStockTextInfo(row)
    },
    async copyToClipboard (text) {
      if (!text) {
        return
      }

      try {
        await navigator.clipboard.writeText(text)

        this.$notify.success({
          title: this.L10n('success'),
          message: this.L10n('copied-to-clipboard')
        })
      } catch {
        this.$notify.error({
          title: this.L10n('error'),
          message: this.L10n('failed-to-copy')
        })
      }
    },
    copyStock ({ row }) {
      const res = this.makeClipboardText({ row })
      this.copyToClipboard(res)
    }
  }
}
</script>
